import { createAction } from "@reduxjs/toolkit";
import api from "../../services/api";

export const deleteUser = createAction("DELETE_USER");
export const signUp = createAction("SIGN_UP");
export const addError = createAction("ADD_ERROR");
export const clearUsers = createAction("CLEAR_USERS");
export const sendEmail = createAction("SEND_EMAIL");
export const resendEmail = createAction("RESEND_EMAIL");
export const upgradeRank = createAction("UPGRADE_RANK");
export const downgradeRank = createAction("DOWNGRADE_RANK");
export const updateUser = createAction("UPDATE_USER");

export const handleDeleteUser = ({ userId }) => {
  return (dispatch) =>
    api
      .delete("/users/:userId", { data: { userId } })
      .then((res) => dispatch(deleteUserSucess(res.data)))
      .catch((err) => Promise.reject(err));
};

const deleteUserSucess = (payload) => deleteUser(payload);

export const handleListTaskAccountable = () => {
  return () =>
    api.get("/users/accountables/task").catch((error) => Promise.reject(error));
};

export const handleListFlowAccountable = () => {
  return () =>
    api.get("/users/accountables/flow").catch((error) => Promise.reject(error));
};

export const handleSignUp = ({ username, password, email }) => {
  return (dispatch) =>
    api
      .post("/auth/sign-up", {
        username,
        password,
        email,
      })
      .then((res) => dispatch(signUpSucess(res.data)))
      .catch((err) => dispatch(signUpFailure(err.message)));
};
const signUpSucess = (payload) => signUp(payload);

const signUpFailure = (error) => addError(error);

export const handleUpgradeRank = ({ userId }) => {
  return (dispatch) =>
    api
      .put("/users/rank/upgrade/", {
        userId,
      })
      .then((res) => dispatch(rankUpgradeSuccess(res.data)))
      .catch((err) => Promise.reject(err));
};
const rankUpgradeSuccess = (payload) => upgradeRank(payload);

export const handleDowngradeRank = ({ userId }) => {
  return (dispatch) =>
    api
      .put("/users/rank/downgrade/", {
        userId,
      })
      .then((res) => dispatch(rankDowngradeSuccess(res.data)))
      .catch((err) => Promise.reject(err));
};
const rankDowngradeSuccess = (payload) => downgradeRank(payload);

//Criação de novas contas gerente e colaborador
export const handleSendEmail = ({ name, email, rank }) => {
  return (dispatch) =>
    api
      .put("/users/send-register-link", {
        name,
        email,
        rank,
      })
      .then((res) => dispatch(sendEmailSucess(res.data)))
      .catch((err) => dispatch(sendEmailFailure(err.message)));
};
const sendEmailSucess = (payload) => sendEmail(payload);

const sendEmailFailure = (error) => Promise.reject(error);

export const handleResendEmail = ({ id }) => {
  return (dispatch) =>
    api
      .put("/users/resend-email", {
        id,
      })
      .then((res) => {
        dispatch(resendEmailSucess(res.data));
      })
      .catch((err) => {
        Promise.reject(err);
      });
};
const resendEmailSucess = (payload) => resendEmail(payload);

export const handleUpdateUser = ({ username, email, enterpriseName }) => {
  return (dispatch) =>
    api
      .put("/users/update/account", {
        username,
        email,
        enterpriseName,
      })
      .then((res) => dispatch(updateUserSucess(res.data)))
      .catch((err) => Promise.reject(err));
};

const updateUserSucess = (payload) => updateUser(payload);

export const handleUpdatePassword = ({ old_password, new_password }) => {
  return (dispatch) =>
    api
      .put("/users/update/password", {
        old_password,
        new_password,
      })
      .then((res) => dispatch(updatePasswordSucess(res.data)))
      .catch((err) => Promise.reject(err));
};

const updatePasswordSucess = (payload) => updateUser(payload);
